var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#000000"}},[_c('myheader',{attrs:{"backFlag":true,"backIntercept":true,"headTitle":"人脸采集"},on:{"childBackEvent":_vm.back}}),_c('div',{staticClass:"scancode all_text_center",attrs:{"id":"scancode"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }